<div class="delete-me">
  <p i18n>Once you delete your account, there is no going back. You will be asked to confirm this action.</p>

  <button (click)="deleteMe()" i18n>Delete your account</button>
</div>
